import styled from 'styled-components'

export const Container = styled.table`
  overflow: auto;
  display: block;
  border-collapse: collapse;
  border-spacing: 0;
`
